import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class SettingsValuesService {

  private _SettingsService: any = {};
  private _isInitialized = false;

  public set SettingsService(value: any) {
    this._isInitialized = true;
    this._SettingsService = value;
  }
  public get SettingsService() {
    return this._SettingsService;
  }

  public get isInitialized() {
    return this._isInitialized;
  }

  public get DateFormat() {
    return this._SettingsService['DateFormat'];
  }
  public get ExcelExportLimit() {
    return this._SettingsService['ExcelExportLimit'];
  }
  public get FootprintApi() {
    return this._SettingsService['FootprintApi'];
  }
  public get MongoDB() {
    return this._SettingsService['MongoDB'];
  }
  public get TimeFormat() {
    return this._SettingsService['TimeFormat'];
  }

  public app: SettingsValuesService = this;

  public get FootPrintPortalManager() {
     return {
DateFormat : this.DateFormat,
ExcelExportLimit : this.ExcelExportLimit,
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB,
TimeFormat : this.TimeFormat
    };
  }
  public get Discussions() {
     return {
FootprintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Utilities() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Addresses() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get AsnOrders() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Attachments() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Carriers() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Instructions() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get ExcelOrderImport() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Locations() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Lots() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get LoadContainers() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Owners() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get PurchaseOrders() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Invoices() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Notifications() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Materials() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get DockAppointments() {
     return {
DateFormat : this.DateFormat,
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB,
TimeFormat : this.TimeFormat
    };
  }
  public get SerialNumbers() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get SalesOrders() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
  public get Inventory() {
     return {
FootPrintAPI : this.FootprintApi,
MongoDB : this.MongoDB
    };
  }
}
